module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/polizas/polizas.component.scss
// module id = ./src/app/Contabilidad/polizas/polizas.component.scss
// module chunks = main